import React from 'react';

import type { VideoWithPlaceholderImageProps } from 'src/components/common/video/video-with-placeholder-image';
import VideoWithPlaceholderImage, {
  VideoType,
} from 'src/components/common/video/video-with-placeholder-image';

export type VimeoVideoDetails = {
  videoId: string;
  videoPlaceholder: Queries.ImageWithCropDetails | Queries.ImageDetails;
};

type VimeoVideoProps = Omit<VideoWithPlaceholderImageProps, 'video'> & {
  video: VimeoVideoDetails;
};

const VimeoVideo = ({ video, ...rest }: VimeoVideoProps) => (
  <VideoWithPlaceholderImage
    video={{
      type: VideoType.VIMEO,
      ...video,
    }}
    {...rest}
  />
);

export default VimeoVideo;
